import { useMutation } from '@tanstack/react-query';
import { createTag } from 'shared/services/backend-api';
import { NewTag } from 'shared/types/tag';

export const useCreateTagMutation = () =>
  useMutation({
    mutationFn: async (tag: NewTag) => createTag(tag),
  });
